import { GeneralSearchType } from './types';

export const generalSearchOptions = [
  { id: GeneralSearchType.ARCHIVAL_AID, label: 'Archivní pomůcka' },
  { id: GeneralSearchType.ARCHIVAL_COLLECTION, label: 'Archivní fond' },
  { id: GeneralSearchType.ARCHIVAL_UNIT, label: 'Archiválie' },
  { id: GeneralSearchType.EAD_NODE, label: 'Uzel EAD' },
];
